import VenderListView from './VenderListView'
import VenderGridView from './VenderGridView'
import { useState } from 'react'
import { Box, Grid, Typography } from '@mui/material'
import VenderFilter from './VenderFilter'

import TabCustom from '../atoms/tab/TabCustom'
import SearchField from '../atoms/search-field/SearchField'
import styles from './venderListStyle.module.scss'
import { useDebouncedCallback } from '../../hooks'
import { setVendorFilters } from '../../features/vendorSlice'
import { useDispatch, useSelector } from 'react-redux'
import CustomTablePagination from '../atoms/table/CustomTablePagination'

const tabData = [
	{
		id: 1,
		tabIcon: (
			<svg
				width="16"
				height="16"
				viewBox="0 0 16 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M13.2663 9H2.73301C1.73301 9 1.33301 9.42667 1.33301 10.4867V13.18C1.33301 14.24 1.73301 14.6667 2.73301 14.6667H13.2663C14.2663 14.6667 14.6663 14.24 14.6663 13.18V10.4867C14.6663 9.42667 14.2663 9 13.2663 9Z"
					stroke="#8692A4"
					strokeWidth="1.33"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M13.2663 1.33398H2.73301C1.73301 1.33398 1.33301 1.76065 1.33301 2.82065V5.51398C1.33301 6.57398 1.73301 7.00065 2.73301 7.00065H13.2663C14.2663 7.00065 14.6663 6.57398 14.6663 5.51398V2.82065C14.6663 1.76065 14.2663 1.33398 13.2663 1.33398Z"
					stroke="#8692A4"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		tabLabel: 'List',
	},
	{
		id: 2,
		tabIcon: (
			<svg
				width="16"
				height="16"
				viewBox="0 0 16 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M14.6667 5.68065V2.65398C14.6667 1.71398 14.24 1.33398 13.18 1.33398H10.4867C9.42667 1.33398 9 1.71398 9 2.65398V5.67398C9 6.62065 9.42667 6.99398 10.4867 6.99398H13.18C14.24 7.00065 14.6667 6.62065 14.6667 5.68065Z"
					stroke="#8692A4"
					strokeWidth="1.33"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M14.6667 13.18V10.4867C14.6667 9.42667 14.24 9 13.18 9H10.4867C9.42667 9 9 9.42667 9 10.4867V13.18C9 14.24 9.42667 14.6667 10.4867 14.6667H13.18C14.24 14.6667 14.6667 14.24 14.6667 13.18Z"
					stroke="#8692A4"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M6.99967 5.68065V2.65398C6.99967 1.71398 6.57301 1.33398 5.51301 1.33398H2.81967C1.75967 1.33398 1.33301 1.71398 1.33301 2.65398V5.67398C1.33301 6.62065 1.75967 6.99398 2.81967 6.99398H5.51301C6.57301 7.00065 6.99967 6.62065 6.99967 5.68065Z"
					stroke="#8692A4"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M6.99967 13.18V10.4867C6.99967 9.42667 6.57301 9 5.51301 9H2.81967C1.75967 9 1.33301 9.42667 1.33301 10.4867V13.18C1.33301 14.24 1.75967 14.6667 2.81967 14.6667H5.51301C6.57301 14.6667 6.99967 14.24 6.99967 13.18Z"
					stroke="#8692A4"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		tabLabel: 'Grid',
	},
]
const VenderListComponent = ({type}) => {
	const dispatch = useDispatch()
	const vendorFilter = useSelector((state) => state.vendor.vendorFilters)
	const vendorTotalCount = useSelector((state) => state.vendor.vendorTotalCount)
	const vendorCurrentPage = useSelector((state) => state.vendor.vendorCurrentPage)
	const vendorSearchListLoading = useSelector(
		(state) => state.vendor.vendorSearchListLoading
	)
	const [search, setSearch] = useState('')
	const [innerTab, setInnerTab] = useState(0)
	const handleInnerTab = (e, tab) => {
		setInnerTab(tab)
	}

	const debounceSearch = useDebouncedCallback((value) => {
		dispatch(
			setVendorFilters({
				...vendorFilter,
				page: 1,
				limit: 10,
				search: value,
			})
		)
	})

	const handleChangePage = (_event, newPage) => {
		dispatch(
			setVendorFilters({
				...vendorFilter,
				page: newPage + 1
			})
		)
	}

	const handleChangeRowsPerPage = (event) => {
		const newLimit = parseInt(event.target.value, 10)
		dispatch(
			setVendorFilters({
				...vendorFilter,
				limit: newLimit,
				page: 1,
			})
		)
	}

	return (
		<section className={styles.vendorsListSection}>
			<Grid container spacing={{ sm: 1, md: 2 }}>
				<Grid size={{ sm: 12, md: 4, lg: 3 }}>
					<VenderFilter />
				</Grid>
				<Grid size={{ sm: 12, md: 8, lg: 9 }}>
					<Box className={styles.vendorListWrp}>
						<div className={styles.searchAndTabRow}>
							<SearchField
								searchPlaceholder={`Search ${type}`}
								searchValue={search}
								onSearchChange={(v) => {
									setSearch(v)
									debounceSearch(v)
								}}
							/>
							<TabCustom
								innerTab={innerTab}
								onInnerTabChange={handleInnerTab}
								tabData={tabData}
								data-cy="view-toggle-tabs"
							/>
						</div>
						<div className={styles.vendorTabContent}>
							{vendorTotalCount === 0 && !vendorSearchListLoading ? (
								<Box
									sx={{
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'center',
										justifyContent: 'center',
										minHeight: '300px',
										textAlign: 'center',
										color: 'text.secondary',
									}}
								>
									<Typography variant="h6" gutterBottom>
										No {type} found
									</Typography>
									<Typography variant="body2">
										{search && `No results match "${search}"`}
									</Typography>
								</Box>
							) : (
								<>
									{innerTab === 0 ? (
										<VenderListView type={type} />
									) : (
										<VenderGridView type={type} />
									)}
								</>
							)}
						</div>
						{vendorTotalCount > 0 && (
							<CustomTablePagination
								page={vendorCurrentPage - 1}
								rowsPerPage={vendorFilter?.limit ?? 10}
								totalCount={vendorTotalCount}
								handleChangePage={handleChangePage}
								handleChangeRowsPerPage={
									handleChangeRowsPerPage
								}
							/>
						)}
					</Box>
				</Grid>
			</Grid>
		</section>
	)
}

export default VenderListComponent
